<div class="app-container">
  
  <section class="toolbar">
    <mat-button-toggle-group [value]="selectedPreset()" (change)="selectedPreset.set($event.value)">
      @for (p of presets; track p.label) {
        <mat-button-toggle [value]="p">{{ p.label }}</mat-button-toggle>
      }
    </mat-button-toggle-group>

    <mat-slide-toggle [checked]="showSafeZones()" (change)="showSafeZones.set($event.checked)">
      Show Safe Zones
    </mat-slide-toggle>
  </section>

  <div class="main-layout">
    <div #imageCanvas class="preview-box" [style.aspect-ratio]="selectedPreset().ratio">
      @if (imageSource()) {
        <img [src]="imageSource()" 
            [ngStyle]="bgCropStyle()"
            class="bg-image-render">
        <img [src]="selectedOverlay().url" 
            class="overlay-logo" 
            [class.has-shadow]="showShadow()"
            [class.has-glow]="showGlow()"
            [style.opacity]="selectedOverlay().opacity"
            [style.width.px]="logoWidth()" 
            [style.top.%]="logoTop()" 
            [style.left.%]="logoLeft()">

        @if (showSafeZones()) {
          <div class="safe-zone-container">
            <div class="safe-zone top"><span>STATUS BAR SAFE AREA</span></div>
            <div class="safe-zone bottom"><span>UI / CAPTION SAFE AREA</span></div>
          </div>
        }
      } @else {
        <div class="placeholder">Upload a photo to begin</div>
      }
    </div>

    <aside class="sidebar">
      <input type="file" (change)="onFileSelected($event)" hidden #fileInput accept="image/*">
      <button mat-flat-button color="primary" (click)="fileInput.click()" hidden>
        <mat-icon>upload</mat-icon> Upload Image
      </button>

      <mat-form-field appearance="outline" class="full-width" *ngIf="propertyImages().length > 0">
        <mat-label>Select Property Image</mat-label>
        <mat-select [value]="imageSource()" (selectionChange)="imageSource.set($event.value)">
          <mat-option *ngFor="let url of propertyImages(); let i = index" [value]="url">
            <div class="dropdown-option">
              <img [src]="url" class="mini-thumb" alt="Image thumbnail">
              <span>Image {{ i + 1 }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="crop-controls">
        <label>Adjust Viewport (Crop)</label>
        
        <label>Horizontal Focus (Left to Right)</label>
        <mat-slider min="0" max="100" step="1">
            <input matSliderThumb [value]="focalX()" (input)="focalX.set($any($event).target.value)">
        </mat-slider>

        <label>Vertical Focus (Top to Bottom)</label>
        <mat-slider min="0" max="100" step="1">
            <input matSliderThumb [value]="focalY()" (input)="focalY.set($any($event).target.value)">
        </mat-slider>

        <button mat-button (click)="focalX.set(50); focalY.set(50);">Reset to Center</button>
      </div>
      <mat-divider></mat-divider>
      <div class="overlay-selector">
          <label>Logo Version</label>
          <mat-button-toggle-group [value]="selectedOverlay()" (change)="selectedOverlay.set($event.value)"
              aria-label="Select Logo Style">
              @for (option of overlayOptions; track option.id) {
              <mat-button-toggle [value]="option">
                  {{ option.label }}
              </mat-button-toggle>
              }
          </mat-button-toggle-group>
      </div>

      <div class="alignment-controls">
          <label>Quick Align</label>
          <div class="button-row">
              <button mat-stroked-button (click)="centerHorizontally()">
                  <mat-icon>format_align_center</mat-icon> Center H
              </button>
              <button mat-stroked-button (click)="centerVertically()">
                  <mat-icon>vertical_align_center</mat-icon> Center V
              </button>
          </div>
      </div>

      <div class="slider-group">
        <label>Logo Size</label>
        <mat-slider min="50" max="400" step="10">
          <input matSliderThumb [value]="logoWidth()" (input)="logoWidth.set($any($event).target.value)">
        </mat-slider>

        <label>Vertical (Top)</label>
        <mat-slider min="0" max="95">
          <input matSliderThumb [value]="logoTop()" (input)="logoTop.set($any($event).target.value)">
        </mat-slider>

        <label>Horizontal (Left)</label>
        <mat-slider min="0" max="95">
          <input matSliderThumb [value]="logoLeft()" (input)="logoLeft.set($any($event).target.value)">
        </mat-slider>
      </div>

      <mat-slide-toggle [checked]="showShadow()" (change)="showShadow.set($event.checked)">
        Add Logo Shadow
      </mat-slide-toggle>

      <mat-slide-toggle [checked]="showGlow()" (change)="showGlow.set($event.checked)">
        Add Logo Glow
      </mat-slide-toggle>

      <button mat-raised-button color="accent" (click)="downloadImage()" [disabled]="!imageSource()">
        <mat-icon>download</mat-icon> Download High-Res
      </button>
    </aside>
  </div>
</div>